import debug from 'debug'

import identifyVisitor from '@/sdk/careshipTracking/src/collector/identifyVisitor'
import { logIn } from '@/sdk/clients/AccountClient'
import { getAndSaveUserToken } from '@/sdk/oauth'
import getAndSaveUserOAuthToken from "@/sdk/oauth/src/getAndSaveUserOAuthToken";
import getRedirectURLAndCode from "@/sdk/oauth/src/getRedirectURLAndCode";

const logger = debug('careship:store/auth')

export default {
  logOut({ commit }) {
    logger('store.action -> auth/logOut')
    commit('deleteAuth')
  },

  async logIn({ dispatch }, credentials) {
    return new Promise(async resolve => {
      logger(
        'store.action -> auth/logIn -> trying to log in with credentials (%O)',
        credentials,
      )

      const authIsValid = await logIn(credentials)
      logger(
        'store.action -> auth/logIn -> %s',
        authIsValid ? 'success' : 'failed',
      )

      if (authIsValid) {
        identifyVisitor()
        dispatch('user/getUserDetails', {}, { root: true })
      }

      resolve(authIsValid)
    })
  },

  authenticate({ commit, dispatch }, credentials) {
    return new Promise(async (resolve, reject) => {
      commit('authRequest') // request loading
      commit('deleteAuth')

      const { email, password } = credentials

      logger(
        'store.action -> authenticate -> credentials (%s, %s)',
        email,
        password,
      )

      const authIsValid = await getAndSaveUserToken(email, password)

      if (authIsValid) {
        identifyVisitor()
        dispatch('user/getUserDetails', {}, { root: true })
        resolve()
      } else {
        commit('authError')
        reject()
      }
    })
  },

  authenticateOAuth({ commit, dispatch }, credentials) {
    return new Promise(async (resolve, reject) => {
      commit('authRequest') // request loading
      commit('deleteAuth')

      const { email, password} = credentials

      logger(
        'store.action -> authenticate -> credentials (%s, %s)',
        email,
        password,
      )

      const authIsValid = await getAndSaveUserOAuthToken(email, password)

      if (authIsValid) {
        resolve(authIsValid)
      } else {
        commit('authError')
        reject()
      }
    })
  },

  approveOAuthConsent({ commit, dispatch }, parameters) {
    return new Promise(async (resolve, reject) => {
      commit('authRequest') // request loading
      commit('deleteAuth')

      const { client_id, client_uuid, redirect_uri, response} = parameters

      const authIsValid = await getRedirectURLAndCode(client_id, client_uuid, redirect_uri, response)

      if (authIsValid) {
        resolve(authIsValid)
      } else {
        commit('authError')
        reject()
      }
    })
  },

  deleteAuth({ commit }) {
    commit('deleteAuth')
  },

  deleteConfigToken({ commit }) {
    commit('deleteConfigToken')
  },
}
